/**
 * Chat home (`/`).
 *
 * Renders the shared `ChatView` with no active conversation — the empty state
 * with suggestion prompts. Sending the first message creates a conversation on
 * the backend and navigates to `/conversations/$id`.
 */
import { ChatView } from '@/components/chat/chat-view'

export function ChatRoute() {
  return <ChatView conversationId={null} />
}

export default ChatRoute
